/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Glyphicon, Modal } from "react-bootstrap";
import AllocateRunsheet from "./AllocateRunsheet";

class AssociateAction extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      cancelling: false,
      errors: false
    };
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  render() {
    return (
      <span>
        <span className="allocate-icon">
          <Glyphicon glyph="link" onClick={this.handleShow} title="Allocate" />
        </span>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Allocate to vehicle</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AllocateRunsheet
              runsheet={this.props.runsheet}
              closeModal={this.handleClose}
              allocateRunsheet={this.props.allocateRunsheet}
              updateVehicle={this.props.updateVehicle}
              removeVehicle={this.props.removeVehicle}
            />
          </Modal.Body>
        </Modal>
      </span>
    );
  }
}
AssociateAction.propTypes = {
  runsheet: PropTypes.object.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

export default AssociateAction;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/actions/AssociateAction.js